const $ = window.jQuery;

// NOTE: It is very important these links (which are hidden to the end user
//   behind a "View More" link) are rendered serverside and then hidden with js,
//   so that they are easily crawleable by search engine bots.  That's why
//   this "component" isn't just a React component with a json payload.
const initViewMoreComponent = ({ el }) => {
  const $el = $(el);
  const $viewMoreLink = $('.view-more-link', $el);
  const $viewMoreItems = $('.view-more-item', $el);
  const initialVisibleCount = $el.data('initialVisibleCount');

  const $additionalViewMoreItems = $viewMoreItems.slice(initialVisibleCount);
  $additionalViewMoreItems.toggle();

  $viewMoreLink.click((e) => {
    e.preventDefault();
    const $link = $(e.currentTarget);
    const oldLinkText = $link.text();
    const newLinkText = $link.data('toggledText');
    $additionalViewMoreItems.toggle();
    $link.text(newLinkText);
    $link.data('toggledText', oldLinkText);
  });
};

const JobListingsApp = () => {
  if (window.IH && window.IH.googleOptimizeEnabled) {
    window.dataLayer.push({ event: 'optimize.activate' });
  }

  $('.view-more-component').each((_, el) => {
    initViewMoreComponent({ el });
  });
};

export default JobListingsApp;
